import React from 'react';

export const DOSHA_COLORS = {
    vata: '#8B5CF6',   // Violet
    pitta: '#EF4444',  // Red
    kapha: '#10B981',  // Emerald
    default: '#2D5A27' // Sage
};

export const DOSHA_INFO = {
    vata: { icon: '💨', name: 'Vata' },
    pitta: { icon: '🔥', name: 'Pitta' },
    kapha: { icon: '🌊', name: 'Kapha' }
};

interface DoshaChipProps {
    dosha: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const DoshaChip: React.FC<DoshaChipProps> = ({ dosha, size = 'md', className = '' }) => {
    const isSama = dosha.toLowerCase() === 'sama';
    
    if (isSama) {
        return (
            <div 
                className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border shadow-sm transition-all hover:scale-105 bg-emerald-50 border-emerald-200 text-emerald-800 ${
                    size === 'sm' ? 'text-[10px]' : size === 'lg' ? 'text-sm' : 'text-xs'
                } ${className}`}
            >
                <span className="flex gap-0.5">
                    <span>💨</span>
                    <span>🔥</span>
                    <span>🌊</span>
                </span>
                <span className="font-bold uppercase tracking-widest">Sama</span>
            </div>
        );
    }

    const baseDosha = dosha.toLowerCase() as keyof typeof DOSHA_INFO;
    const info = DOSHA_INFO[baseDosha] || { icon: '❔', name: dosha };
    const color = DOSHA_COLORS[baseDosha] || DOSHA_COLORS.default;
    
    return (
        <div 
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border shadow-sm transition-all hover:scale-105 ${
                size === 'sm' ? 'text-[10px]' : size === 'lg' ? 'text-sm' : 'text-xs'
            } ${className}`}
            style={{ 
                backgroundColor: `${color}15`, 
                borderColor: `${color}40`,
                color: color 
            }}
        >
            <span className="text-base">{info.icon}</span>
            <span className="font-bold uppercase tracking-wider">{dosha}</span>
        </div>
    );
};

export default DoshaChip;
